/**
 * Navigations-JavaScript.
 *
 * Zwei getrennte Zustaendigkeiten. Eine dritte, der Bootstrap-Ersatz fuer
 * data-bs-toggle="collapse", ist am 2026-08-25 entfallen: Burger-Schublade
 * und der Plugin-Block ww/faq arbeiten beide nativ, der eine mit .is-open,
 * der andere mit <details name>.
 *
 *   1. Untermenues (<details class="ww-mega"> / <details class="ww-sub">)
 *      Diese funktionieren OHNE dieses Skript: auf-/zuklappen, Tastatur und
 *      Screenreader-Ansage macht der Browser. Hier kommt nur dazu, was HTML
 *      nicht kann – Escape, Klick daneben, Schliessen-Schaltflaeche und das
 *      Schliessen von Geschwistern in Browsern ohne <details name>.
 *
 *   2. Klebender Header (.site-header.header--sticky)
 *      Misst, was beim Scrollen stehen bleibt, und meldet den
 *      Angeheftet-Zustand. Der Header klebt auch ohne dieses Skript - hier
 *      entstehen nur die Masse fuer Sprungmarken und Panelhoehen.
 */
( function () {
	'use strict';

	/* ---------- Burger-Schublade ---------- */

	function drawerOf( trigger ) {
		var id = trigger.getAttribute( 'aria-controls' );

		return id ? document.getElementById( id ) : null;
	}

	function setDrawer( trigger, isOpen ) {
		var drawer = drawerOf( trigger );

		if ( ! drawer ) {
			return;
		}

		drawer.classList.toggle( 'is-open', isOpen );
		trigger.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	}

	function toggleDrawer( trigger ) {
		var drawer = drawerOf( trigger );

		setDrawer( trigger, drawer ? ! drawer.classList.contains( 'is-open' ) : false );
	}

	function openDrawerTrigger() {
		return document.querySelector( '[data-ww-toggle="drawer"][aria-expanded="true"]' );
	}

	/* ---------- Untermenues ---------- */

	var PANEL = 'details.ww-disclosure';

	function openPanels( except ) {
		return Array.prototype.filter.call(
			document.querySelectorAll( PANEL ),
			function ( panel ) {
				return panel.open && panel !== except;
			}
		);
	}

	/**
	 * Schliesst ein Panel und gibt den Fokus an sein <summary> zurueck.
	 *
	 * Ohne die Fokusrueckgabe stuende der Fokus im gerade ausgeblendeten
	 * Panel – der naechste Tab begaenne wieder am Seitenanfang.
	 */
	function closePanel( panel, moveFocus ) {
		if ( ! panel || ! panel.open ) {
			return;
		}

		panel.open = false;

		var summary = panel.querySelector( ':scope > summary' );

		if ( moveFocus && summary && summary.focus ) {
			summary.focus();
		}
	}

	// Nur eines gleichzeitig offen. Browser mit <details name> erledigen das
	// selbst; fuer aeltere ist dieser Handler der Ersatz.
	document.addEventListener( 'toggle', function ( event ) {
		var panel = event.target;

		if ( ! panel.open || ! panel.matches( PANEL ) ) {
			return;
		}

		openPanels( panel ).forEach( function ( other ) {
			closePanel( other, false );
		} );
	}, true );

	/* ---------- Verdrahtung ---------- */

	document.addEventListener( 'click', function ( event ) {
		var drawerTrigger = event.target.closest( '[data-ww-toggle="drawer"]' );

		if ( drawerTrigger ) {
			event.preventDefault();
			toggleDrawer( drawerTrigger );
			return;
		}

		// Schliessen-Schaltflaeche innerhalb eines Panels.
		var dismissTrigger = event.target.closest( '[data-ww-dismiss="panel"]' );

		if ( dismissTrigger ) {
			event.preventDefault();
			closePanel( dismissTrigger.closest( PANEL ), true );
			return;
		}

		// Klick ausserhalb schliesst offene Panels. Ein Klick INNERHALB laesst
		// sie offen – sonst waere ein Formular oder eine Karte im Panel nicht
		// bedienbar.
		if ( ! event.target.closest( PANEL ) ) {
			openPanels( null ).forEach( function ( panel ) {
				closePanel( panel, false );
			} );
		}
	} );

	/* ---------- Klebender Header ---------- */

	/**
	 * Misst den Header und schreibt zwei Werte an <html>:
	 *
	 *   --ww-header-height          was beim Scrollen stehen bleibt
	 *   --ww-header-utility-height  was darueber wegscrollt (Subheadline)
	 *
	 * Gemessen statt konfiguriert, weil die Hoehe von Logo, Schriftgroesse
	 * und Umbruch abhaengt - ein fester Wert waere auf halber Strecke falsch.
	 * Ohne dieses Skript greifen die Fallbacks aus theme.json.
	 */
	function trackHeader() {
		var header = document.querySelector( '.site-header.header--sticky' );

		if ( ! header ) {
			return;
		}

		var utility = header.querySelector( '.site-header__utility' );
		var drawer  = header.querySelector( '.ww-nav-drawer' );
		var toggle  = header.querySelector( '.ww-nav-toggle' );
		var root    = document.documentElement;
		var last    = {};

		function height( el ) {
			return el ? el.getBoundingClientRect().height : 0;
		}

		/**
		 * Schreibt nur, wenn sich der Wert wirklich geaendert hat.
		 *
		 * Jede Zuweisung kann Layout und damit den ResizeObserver erneut
		 * ausloesen. Ohne diesen Vergleich laeuft der Beobachter im Kreis,
		 * auch wenn die Zahl dieselbe bleibt.
		 */
		function set( name, value ) {
			var px = Math.round( value * 100 ) / 100;

			if ( last[ name ] === px ) {
				return;
			}

			last[ name ] = px;
			root.style.setProperty( name, px + 'px' );
		}

		function measure() {
			var total = height( header );
			var above = height( utility );

			// Die aufgeklappte Burger-Schublade zaehlt nicht zur stehenden
			// Hoehe. Sonst entsteht eine Rueckkopplung: Schublade wird
			// hoeher -> Header wird hoeher -> --ww-header-height waechst ->
			// max-height der Schublade schrumpft -> Header schrumpft. Das
			// Ergebnis ist ein zitternder Header.
			//
			// Der Burger ist ab 992px ausgeblendet: ist er sichtbar, liegt
			// die Schublade als eigene Zeile unter der Leiste. Das ist der
			// Hinweis auf die Mobilansicht, ohne den Breakpoint hier ein
			// zweites Mal zu schreiben.
			if ( toggle && toggle.offsetParent !== null ) {
				total -= height( drawer );
			}

			set( '--ww-header-utility-height', above );
			set( '--ww-header-height', total - above );
		}

		measure();

		if ( window.ResizeObserver ) {

			// Ein Frame Verzoegerung fasst mehrere Meldungen zusammen und
			// haelt die Messung ausserhalb des laufenden Layout-Durchgangs.
			var pending  = false;
			var observer = new ResizeObserver( function () {

				if ( pending ) {
					return;
				}

				pending = true;

				window.requestAnimationFrame( function () {
					pending = false;
					measure();
				} );
			} );

			observer.observe( header );

			if ( utility ) {
				observer.observe( utility );
			}
		} else {
			window.addEventListener( 'resize', measure );
		}

		// Angeheftet-Zustand ueber ein Sentinel vor dem Header, nicht ueber
		// einen scroll-Listener: der Browser meldet die Kreuzung selbst,
		// ohne bei jedem Scrollschritt Code auszufuehren.
		if ( ! window.IntersectionObserver || ! header.parentNode ) {
			return;
		}

		var sentinel = document.createElement( 'div' );

		sentinel.setAttribute( 'aria-hidden', 'true' );
		sentinel.style.cssText = 'position:absolute;height:1px;width:1px;pointer-events:none;visibility:hidden';
		header.parentNode.insertBefore( sentinel, header );

		new IntersectionObserver( function ( entries ) {
			header.classList.toggle( 'is-pinned', ! entries[ 0 ].isIntersecting );
		} ).observe( sentinel );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', trackHeader );
	} else {
		trackHeader();
	}

	document.addEventListener( 'keydown', function ( event ) {
		if ( event.key !== 'Escape' ) {
			return;
		}

		var open = openPanels( null );

		if ( ! open.length ) {

			// Kein Panel offen: dann schliesst Escape die Schublade.
			var drawerTrigger = openDrawerTrigger();

			if ( drawerTrigger ) {
				setDrawer( drawerTrigger, false );

				if ( drawerTrigger.focus ) {
					drawerTrigger.focus();
				}
			}

			return;
		}

		// Das Panel, in dem der Fokus steht, bekommt ihn zurueck.
		var focused = event.target.closest ? event.target.closest( PANEL ) : null;

		open.forEach( function ( panel ) {
			closePanel( panel, panel === focused );
		} );

		if ( ! focused ) {
			closePanel( open[ open.length - 1 ], true );
		}
	} );
}() );
